import React from 'react'
import Slider from "react-slick";

export default function Footer() {

    // 09. Home-1-Slider js
    const slider = {
        speed: 7000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                }
            },
            {
                breakpoint: 992,
                settings: {
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <>
            <div className="footer-bottom-content tp-browser-bg-shape" data-background="/img/footer/overly.png" style={{ backgroundImage: "url(/img/footer/overly.png)" }}>

                <footer>
                    {/* <!-- tp-footer-feature-slide-start --> */}
                    <div className="tp-footer-slide pb-80">
                        <div className="container-fluid g-0">
                            <div className="row g-0 justify-content-center">
                                <div className="footer-slide-active">
                                    <Slider {...slider}>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>GST Billing</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item"> 
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Inventory Management</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Payment Reminder</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Invoice Sharing</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Stock and Party Journal</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>POS Billing</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Generate E - Way bill</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Bulk Item/Party upload</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Multiple Invoice theme</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Create Staff User</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Smart Dashboard</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Customized User Role</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Barcode Generator and Printing</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Profit & Loss Statement</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Multiple business Report</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Manage Expenses</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Manage Cash and Bank Balance</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>SMS marketing</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Generate E - Invoicing</span>
                                            </div>
                                        </div>
                                        <div className="footer-slide-wrapper">
                                            <div className="footer-slide-item">
                                                <i className="fa-regular fa-circle-check"></i>
                                                <span>Real Time Analytics</span>
                                            </div>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- tp-footer-feature-slide-end --> */}

                    {/* <!-- tp-footer-area-start --> */}
                    <div className="tp-footer__pl-pr">
                        <div className="tp-footer__area tp-footer__tp-border-bottom">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xl-3 col-lg-3 col-md-6 pb-30 wow tpfadeUp" data-wow-duration=".9s"
                                        data-wow-delay=".3s">
                                        <div className="tp-footer__widget footer-widget-3 footer-col-3-1">
                                            <div className="tp-footer__logo mb-25">
                                                <a href="index.html">
                                                    <img src="/img/logo/billwale_logo.png" alt="" />
                                                </a>
                                            </div>
                                            <div className="tp-footer__contact-info">
                                                <p>Build a modern and creative website with crealand</p>
                                                <ul>
                                                    <li>
                                                        <span className="phone_img m-1 me-3">
                                                            <img src="/img/logo/phone.png" alt="" />
                                                        </span>
                                                        <a className="first-child ms-5" href="http://wa.me/+819904010333">99040 10333</a>
                                                    </li>
                                                    <li className="mt-3">
                                                        <span className="phone_img m-1 me-3">
                                                            <img src="/img/logo/phone.png" alt="" />
                                                        </span>
                                                        <a className="first-child ms-5" href="http://wa.me/+918999890009">89998 90009</a>
                                                    </li>
                                                    <li className="mt-2">
                                                        <span>
                                                            <img src="/img/logo/email.gif" alt="" />
                                                        </span>
                                                        <a href="mailto:team@info.com">team@billwale.com</a>
                                                    </li>
                                                    <li>
                                                        <span>
                                                            <span>
                                                                <img src="/img/logo/email.gif" alt="" />
                                                            </span>
                                                        </span>
                                                        <a href="mailto:admin@info.com">admin@billwale.com</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 pb-30 wow tpfadeUp" data-wow-duration=".9s"
                                        data-wow-delay=".5s">
                                        <div className="tp-footer__widget footer-widget-3 footer-col-3-2">
                                            <h4 className="tp-footer__widget-title">Navigation</h4>
                                            <div className="tp-footer__content">
                                                <ul>
                                                    <li><a href=".">Demo page</a></li>
                                                    <li><a href=".">About</a></li>
                                                    <li><a href=".">Pricing Plan</a></li>
                                                    <li><a href=".">Integrations</a></li>
                                                    <li><a href=".">Blog</a></li>
                                                    <li><a href=".">Contact</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-2 col-lg-2 col-md-6 pb-30 wow tpfadeUp" data-wow-duration=".9s"
                                        data-wow-delay=".7s">
                                        <div className="tp-footer__widget footer-widget-3 footer-col-3-3">
                                            <h4 className="tp-footer__widget-title">Other Pages</h4>
                                            <div className="tp-footer__content">
                                                <ul>
                                                    <li><a href=".">Features</a></li>
                                                    <li><a href=".">Team</a></li>
                                                    <li><a href=".">Careers</a></li>
                                                    <li><a href=".">Login</a></li>
                                                    <li><a href=".">Register</a></li>
                                                    {/* <!-- <li><a href="#">404 Not found</a></li> --> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-6 pb-30 wow tpfadeUp" data-wow-duration=".9s"
                                        data-wow-delay=".9s">
                                        <div className="tp-footer__widget footer-widget-3 footer-col-3-4">
                                            <h4 className="tp-footer__widget-title">Our Newsletter</h4>
                                            <div className="tp-footer__input mb-35 p-relative">
                                                <form action="#">
                                                    <input type="text" placeholder="Business email adress" />
                                                    <span>
                                                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M13 14.6H5C2.6 14.6 1 13.4 1 10.6V5C1 2.2 2.6 1 5 1H13C15.4 1 17 2.2 17 5V10.6C17 13.4 15.4 14.6 13 14.6Z"
                                                                stroke="#5F6168" strokeWidth="1.5" strokeMiterlimit="10"
                                                                strokeLinecap="round" strokeLinejoin="round" />
                                                            <path opacity="0.4"
                                                                d="M13 5.39993L10.496 7.39993C9.672 8.05593 8.32 8.05593 7.496 7.39993L5 5.39993"
                                                                stroke="#5F6168" strokeWidth="1.5" strokeMiterlimit="10"
                                                                strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                    <button>
                                                        <svg width="14" height="16" viewBox="0 0 14 14" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1.00098 7H13.001" stroke="currentColor" strokeWidth="2"
                                                                strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M7.00098 1L13.001 7L7.00098 13" stroke="currentColor"
                                                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </button>
                                                </form>
                                            </div>
                                            <div className="tp-footer__social-3">
                                                <h4>Social media</h4>
                                                <a href="."><i className="fab fa-facebook-f"></i></a>
                                                <a href="."><i className="fab fa-twitter"></i></a>
                                                <a href="."><i className="fab fa-instagram"></i></a>
                                                <a href="."><i className="fab fa-vimeo-v"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tp-copyright__area pt-25 pb-40">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="tp-copyright__text tp-copyright__text-3 text-center">
                                            <span>Full Copyright & Design By <a href=".">@Theme pure</a> – 2023</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- tp-footer-area-end --> */}
                </footer>
            </div>
        </>
    )
}
